import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { specialismPoints, specialismImage } from '../mock';

export default function Specialism() {
  return (
    <section id="specialism" className="relative py-24 md:py-36 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-px bg-[#e4cfaf]" />
              <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">Our Specialism</span>
            </div>
            <h2 className="serif text-white text-4xl md:text-6xl leading-[1.05] mb-8">
              HMO management, <span className="italic-serif">done properly.</span>
            </h2>
            <p className="text-white/60 text-lg leading-relaxed mb-10 max-w-xl">
              Houses in Multiple Occupation demand specialist knowledge — from licensing and fire safety to room configuration and tenant mix. It is the single discipline we have built our entire business around, and where landlords see us deliver the strongest, most reliable returns.
            </p>

            <div className="space-y-8 border-t border-white/10 pt-8">
              {specialismPoints.map((p) => (
                <div key={p.title} className="pb-8 border-b border-white/10 last:border-b-0 last:pb-0">
                  <h4 className="serif text-white text-xl md:text-2xl mb-2">{p.title}</h4>
                  <p className="text-white/60 leading-relaxed">{p.body}</p>
                </div>
              ))}
            </div>

            <a href="#contact" className="btn-primary mt-10 px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm">
              Discuss your HMO <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm border border-white/10">
              <img src={specialismImage} alt="Managed HMO interior" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-8 -left-8 md:-bottom-10 md:-left-10 bg-[#0f0f10] border border-white/10 px-8 py-6 rounded-sm">
              <div className="serif text-[#e4cfaf] text-5xl md:text-6xl leading-none">98%</div>
              <div className="uppercase text-[10px] tracking-[0.24em] text-white/60 mt-2">Landlord satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
